import { useMemo } from 'react';
import { useGetBooksetQuery } from '@/store/api/betApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useAppSelector } from '@/hooks';
import { getDeltaExposure, isGuestUser } from '@/utils';

export const useMarketExposureData = (marketId?: string, eventId?: string) => {
  const betDetails = useAppSelector((state) => state.bet);
  const isGuest = isGuestUser();
  // API Bookset
  const {
    data: booksetData,
    isLoading,
    isFetching,
  } = useGetBooksetQuery(eventId ?? skipToken, { skip: isGuest });

  // Current market bookset
  const marketBookset = useMemo(
    () => booksetData?.find((item) => item?.marketExternalId == marketId),
    [booksetData, marketId]
  );

  // Exposure getter
  const getBooksetBySelectionId = (id: number | string) => {
    const selection = marketBookset?.selections?.find((item) => item?.selectionId == id);

    const apiExposure = selection?.exposure || 0;

    const deltaExposure = getDeltaExposure(id, marketId, betDetails);

    return {
      apiExposure,
      deltaExposure,
      totalExposure: apiExposure + deltaExposure,
    };
  };

  return {
    isLoading: isLoading || isFetching,
    marketBookset,
    getBooksetBySelectionId,
  };
};
